import {User}									from '../user/interface';
import {ApiCompanyBundleState,
	ApiDeleteCompanyBundleState}				from './interface';

import * as API									from '../../ressources/API';


export default {
	getCompanyBundleApi: async (user: User) => {
		const response = await API.getCompanyBundle(user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	postCompanyBundleApi: async (data: ApiCompanyBundleState) => {
		const response = await API.postCompanyBundle(data.data, data.user);
		if (!response || !response.status)
			return response;
		return response.data;
	},
	putCompanyBundleApi: async (data: ApiCompanyBundleState) => {
		if (!data.idBundle)
			return;
		const response = await API.putCompanyBundle(data.idBundle, data.data, data.user);
		if (!response || !response.status)
			return response;
		return response.data;
	},
	deleteCompanyBundleApi: async (data: ApiDeleteCompanyBundleState) => {
		const response = await API.deleteCompanyBundle(data.idBundle, data.user);
		if (!response || !response.status)
			return null;
		return data.idBundle;
	}
};
